import React from 'react'
import { useSelector } from 'react-redux'
import { CircularProgress, Backdrop, Box } from '@material-ui/core'

export default function BackdropLoader() {
  const open = useSelector(({ status: { backdropLoading } }) => backdropLoading)

  return (
    <Box component={Backdrop} zIndex={1500} open={open}>
      <CircularProgress />
    </Box>
  )
}
